import { Link } from 'react-router-dom';
import { categories, products } from '@/mocks/products';

export default function CategoryShowcase() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3 font-heading">
              <a href="#category-showcase">产品系列</a>
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-[500px] mx-auto">
              从日常保暖到户外探险，热久久为每一种寒冷场景提供专业解决方案
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-12">
            {categories.map((cat) => {
              const count = products.filter((p) => p.categoryId === cat.id).length;
              return (
                <Link
                  key={cat.id}
                  to={`/categories?tab=${cat.id}`}
                  className="group bg-background-50 rounded-xl p-6 transition-all duration-300 hover:bg-background-50 border border-background-200/70"
                >
                  <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-500 transition-colors duration-300">
                    <i className={`${cat.icon} text-xl text-primary-600 group-hover:text-background-50 transition-colors duration-300`}></i>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-900 mb-1.5 font-heading">{cat.name}</h3>
                  <p className="text-sm text-foreground-600 mb-3">{cat.description}</p>
                  <span className="text-xs text-primary-600 font-medium">{count}款产品</span>
                </Link>
              );
            })}
          </div>

          <div className="text-center">
            <Link
              to="/categories"
              className="inline-flex items-center gap-2 px-6 py-3 bg-secondary-100 hover:bg-secondary-200 text-secondary-700 rounded-lg text-sm font-medium transition-colors duration-200 whitespace-nowrap"
            >
              查看全部产品
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}